<div
  class="relative group h-16.25 w-55"
  [ngClass]="{ expanded: node?.expanded }"
>
  <div
    (click)="onClickNode($event, node)"
    (keypress)="onClickNode($event, node)"
    tabindex="0"
    [ngClass]="{
      'border-dashed border-gray-400': !node,
      'border-solid border-gray-200': node,
    }"
    class="max-w-sm bg-white border rounded-lg shadow-sm hover:bg-gray-100 flex items-center h-full w-full p-2 cursor-pointer"
  >
    @if (node) {
      <div class="flex items-center justify-between w-full h-full gap-2">
        <span
          class="flex-1 font-semibold text-sm text-gray-700 text-center pr-1"
        >
          {{ node?.name }}
        </span>

        <div class="shrink-0">
          <button
            mat-icon-button
            [matMenuTriggerFor]="cardMenu"
            aria-label="Opzioni per il nodo"
            (click)="$event.stopPropagation()"
            class="text-gray-500 hover:bg-gray-200"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
        </div>
    </div>

      <mat-menu #cardMenu="matMenu" xPosition="before">
        @let isAmbulatorio = node?.nomeTipologia?.toLowerCase()?.includes('ambulatorio');
        <button
          mat-menu-item
          (click)="onClickUpdateNode($event)"
          [attr.aria-label]="
            (isAmbulatorio ? 'Visualizza' : ('GENERAL.edit' | translate)) +
            ' ' +
            node?.name
          "
        >
          <mat-icon class="material-icons-outlined">
            {{ isAmbulatorio ? 'visibility' : 'edit' }}
          </mat-icon>
          <span>
            {{ isAmbulatorio ? 'Visualizza' : ('GENERAL.edit' | translate) }}
          </span>
        </button>
        <button
          mat-menu-item
          (click)="onClickDeleteNode($event)"
          [attr.aria-label]="('GENERAL.delete' | translate) + ' ' + node?.name"
        >
          <mat-icon class="material-icons-outlined">delete</mat-icon>
          <span>{{ 'GENERAL.delete' | translate }}</span>
        </button>
      </mat-menu>
    } @else {
      <div
        tabindex="0"
        (keydown)="onClickNode($event)"
        (click)="onClickNode($event)"
        class="flex items-center justify-center w-full h-full"
      >
        <mat-icon
          matTooltip="Aggiungi struttura"
          aria-label="Aggiungi nodo"
          fontIcon="add"
        ></mat-icon>
      </div>
    }
  </div>
</div>
